import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import FormItem from '../../components/form/FormItem'
import { MdTitle } from 'react-icons/md'
import { BiX } from 'react-icons/bi'
import { Button, Form } from 'reactstrap'
import { ToSeoUrl } from '../../components/general/SeoUrl'
import DragDropFiles from '../../components/form/DragDropFiles'
import { fetchShowcaseGet } from '../../redux/slices/showcaseGetSlice'
import { fetchShowcaseCreate } from '../../redux/slices/showcaseCreateSlice'
import { fetchShowcaseUpdate } from '../../redux/slices/showcaseUpdateSlice'
import CkItem from '../../components/form/CkItem'

const CrudNews = ({ showMenu, setShowMenu, setChanged, setSelectedItem, selectedItem, t }) => {
    const [formData, setFormData] = useState({ files: [] })
    const dispatch = useDispatch()

    const getData = async () => {
        if (selectedItem !== 0) {
            var data = await dispatch(fetchShowcaseGet({ id: selectedItem }))
            if (data.payload) {
                setFormData({
                    files: data.payload?.files,
                    titletr: data.payload?.title["tr"] || "",
                    titleen: data.payload?.title["en"] || "",
                    slugtr: data.payload?.slug["tr"] || "",
                    slugen: data.payload?.slug["en"] || "",
                    specialField1tr: data.payload?.specialField1["tr"] || "",
                    specialField1en: data.payload?.specialField1["en"] || "",
                })
            }
        }
    }

    const closeModal = () => {
        setFormData({ files: [], slugtr: "", slugen: "", titletr: "", titleen: "", specialField1tr: "", specialField1en: "" })
        setShowMenu(!showMenu)
        setSelectedItem(0)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const title = { "tr": formData.titletr, "en": formData.titleen }
        const slug = { "tr": ToSeoUrl(formData.titletr), "en": ToSeoUrl(formData.titleen) }
        const description = {}
        const content = {}
        const specialField1 = { "tr": formData.specialField1tr, "en": formData.specialField1en }

        const filesToKeep = formData.files
            .filter(file => typeof file === 'string' || !file.file)
            .map(file => typeof file === 'string' ? file : file.preview);

        const newFiles = formData.files.filter(file => file.file);

        await dispatch(
            selectedItem === 0 ?
                fetchShowcaseCreate({
                    file: newFiles,
                    slug: slug,
                    title: title,
                    description: description,
                    content: content,
                    isNews: true,
                    specialField1: specialField1
                }) :
                fetchShowcaseUpdate({
                    id: selectedItem,
                    file: newFiles,
                    filesToKeep: filesToKeep,
                    slug: slug,
                    title: title,
                    description: description,
                    content: content,
                    isNews: true,
                    specialField1: specialField1
                })
        )
        closeModal()
        setChanged(true)
        getData()
        setShowMenu(false)
    }

    useEffect(() => { getData() }, [dispatch, selectedItem])

    return (
        <div className={showMenu ? 'right-popup' : 'd-none'}>
            <div className='right-popup-close' onClick={closeModal}><BiX size={24} /></div>
            <div className='right-popup-menu'>
                <div className='mb-3 text-center'><h5>{t(selectedItem === 0 ? "add_showcase" : "edit_showcase")}</h5></div>
                <Form onSubmit={handleSubmit}>
                    <DragDropFiles
                        formData={formData}
                        setFormData={setFormData}
                        selectedItem={selectedItem}
                        title={t("images")}
                    />
                    <FormItem
                        id={`titletr`}
                        name={`titletr`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("title")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='titletr'
                    />
                    <FormItem
                        id={`titleen`}
                        name={`titleen`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("title")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='titleen'
                    />
                    <FormItem
                        id={`specialField1tr`}
                        name={`specialField1tr`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("date")} (TR)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='specialField1tr'
                    />
                    <FormItem
                        id={`specialField1en`}
                        name={`specialField1en`}
                        type="text"
                        icon={<MdTitle size={20} />}
                        title={`${t("date")} (EN)`}
                        formData={formData}
                        setFormData={setFormData}
                        keyT='specialField1en'
                    />

                    <div className='d-flex justify-content-end mt-4 w-100'>
                        <Button type='submit' color={selectedItem === 0 ? 'primary' : 'warning'} className="text-white">
                            {t(selectedItem === 0 ? "add" : "edit")}
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default CrudNews